import ModalWrapper from "components/common/modals/modalWrapper/ModalWrapper";
import UserTransmissionProgressReportForm from "../forms/UserTransmissionProgressReportForm";

const UserTransmissionProgressReportModal = ({ onClose }) => {
  return (
    <ModalWrapper
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      show={true}
      onClose={onClose}
      title="User Transmission Progress Report"
    >
      <UserTransmissionProgressReportForm onClose={onClose} />
    </ModalWrapper>
  );
};

export default UserTransmissionProgressReportModal;
